import { ActionButton, getId, Modal } from "@fluentui/react";
import { baseUrlUser } from "../../../../constants/url.constant";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { ProductUtils } from "../../../products/views/ProductUtils";
import { OrderModel, OrderStatus } from "../../models/OrderModel";
import OrderDetailHeaderView from "../admin/details/OrderDetailHeaderView";
import OrderTrackingView from "../shared/OrderTrackingView";
import { OrderUtils } from "../shared/OrderUtils";

type OrderDetailProps = {
    order: OrderModel;
    onClose: () => void;
    onDelete: (id: number) => void;
    onPlaceOrder: (id: number) => void;
    onInvoiceDetail: (id: string) => void;
}

export default function OrderDetailView({
    order, onClose, onDelete, onPlaceOrder, onInvoiceDetail
}: OrderDetailProps) {
    const isMobile = window.innerWidth <= 500;
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const width3 = Utils.getColumnWidth(3);
    const width12 = Utils.getColumnWidth(12);
    const width9 = Utils.getColumnWidth(9);

    let url = order.product ? ProductUtils.getImageUrl(baseUrlUser, order.product.picture) : "";

    const productInfo = () => {
        return <>
            <div className="font-bolder">
                <span>{OrderUtils.getStatusText(order.status)}</span>
                {/*{order.tracking !== null &&*/}
                {/*    <span> - {OrderTracking[order.tracking ?? OrderTracking.none]}</span>}*/}
            </div>

            <div className="pt-5">{Utils.formatShortDate(order.orderDate)}</div>

            {!Utils.isNullOrEmpty(order.invoiceId) && <>
                <div
                    onClick={() => onInvoiceDetail(order.invoiceId ?? "")}
                    className="pt-5 cursor"
                    style={{ textDecoration: "underline" }}
                >{order.invoiceId}</div>
            </>}

            <div className="pv-5">{OrderUtils.ProductInfo(order)}</div>
        </>;
    }

    const priceHeader = () => {
        return <div className="ms-Grid-row font-bolder blue-background pv-10">
            <div className={width3 + " left"}>Price</div>
            <div className={width3 + " right"}>Qty</div>
            <div className={width3 + " right"}>Rate</div>
            <div className={width3 + " right"}>Amount</div>
        </div>;
    }

    const priceRow = () => {
        return <div className="ms-Grid-row pv-10">
            <div className={width3 + " left"}>$ {order.price.toFixed(2)}</div>
            <div className={width3 + " right"}>{order.qty}</div>
            <div className={width3 + " right"}>{order.rate}%</div>
            <div className={width3 + " right"}>$ {OrderUtils.getAmount(order).toFixed(2)}</div>
        </div>;
    }

    const domesticShipping = () => {
        return <div className="ms-Grid-row font-bolder blue-background pv-10">
            <div className={width9 + " right"}>Shipping in US</div>
            <div className={width3 + " right"}>$ {order.domesticShipping.toFixed(2)}</div>
        </div>;
    }

    const shippingSummary = () => {
        const rate = order.shippingRate.toFixed(1);
        const weight = order.chargeWeight.toFixed(1) + " lbs";
        const fee = order.shippingRate * order.chargeWeight;

        return <div className="ms-Grid-row blue-background pv-10">
            <div className={width9 + " right"}>Shipping (${rate} x {weight})</div>
            <div className={width3 + " right"}>$ {fee.toFixed(2)}</div>
        </div>;
    }

    const totalSummary = () => {
        return <div className="ms-Grid-row font-bolder blue-background pv-10">
            <div className={width9 + " right"}>Total</div>
            <div className={width3 + " right"}>$ {OrderUtils.getTotal(order).toFixed(2)}</div>
        </div>;
    }

    const onProductDetail = () => {
        if (order.product && order.product.link) {
            window.open(order.product.link, "_blank");
        } else {
            alert("Product link not available.");
        }
    }

    const deleteButton = () => {
        return <ActionButton
            iconProps={{ iconName: "Delete" }}
            onClick={() => onDelete(order.id)}
        >Delete</ActionButton>
    }

    const orderButton = () => {
        return <ActionButton
            iconProps={{ iconName: "ShoppingCart" }}
            onClick={() => onPlaceOrder(order.id)}
        >Place Order</ActionButton>
    }

    const actionRow = () => {
        if (order.status !== OrderStatus.request && order.status !== OrderStatus.quote) {
            return <></>;
        }

        return <div className="ms-Grid-row primary-background-color">
            <div className={width12 + " center"}>
                {order.status === OrderStatus.request && deleteButton()}
                {order.status === OrderStatus.quote && orderButton()}
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            <OrderDetailHeaderView order={order} showCustomer={false} onClose={onClose} />

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body"}>
                <div className="ms-Grid">
                    <div className="ms-Grid-row pb-10">
                        <div className={width9}>
                            {productInfo()}
                        </div>
                        <div className={width3}>
                            <div className="cursor" onClick={onProductDetail}>
                                {OrderUtils.image(url, 0, 80, 0, false)}
                            </div>
                        </div>
                    </div>

                    {priceHeader()}
                    {priceRow()}
                    {order.domesticShipping !== 0 && domesticShipping()}
                    {shippingSummary()}
                    {totalSummary()}

                    {OrderUtils.ShowTracking(order) && <div className="ms-Grid-row pt-15 pb-5">
                        <OrderTrackingView trackings={order.trackings} />
                    </div>}

                    {actionRow()}
                </div>
            </div>
        </Modal>
    </>;
}